import { useGetAllMySuppliers } from '@/api/supplier.api';
import ViewHotelForm from '@/components/hotel/ViewHotelForm';
import Loader from '@/components/ui/Loader';
import { useGetHotel } from '@/hooks/useHotel';
import { useResourceLanguage } from '@/hooks/useResourceLanguage';
import { memo } from 'react';
import { useParams } from 'react-router';

const ViewHotelFormMemo = memo(ViewHotelForm);

const ViewHotelPage = () => {
  const { benefitId = '' } = useParams();

  const { language, setLanguage } = useResourceLanguage();

  const { data: hotel, isLoading, isSuccess } = useGetHotel(benefitId);
  const { data: suppliers } = useGetAllMySuppliers();

  return isLoading ? (
    <Loader />
  ) : (
    isSuccess && (
      <ViewHotelFormMemo
        hotel={hotel}
        suppliers={suppliers}
        language={language}
        setLanguage={setLanguage}
        key={`hotel-${hotel.id}`}
      />
    )
  );
};

export default ViewHotelPage;
